module.exports = __webpack_public_path__ + "img/crown.3d71b9a0.svg";